import About from '../Tabs/About/About'
import Home from '../Tabs/Home/Home'
import Project from '../Tabs/Projects/Projects'
import Project1 from '../Tabs/Projects/Project1'
import Project2 from '../Tabs/Projects/Project2'
import Project3 from '../Tabs/Projects/Project3'
import Project4 from '../Tabs/Projects/Project4'

export const NavRoute = {
    home: '/',
    about: '/about',
    projects: '/projects',
    project1: '/projects/iluvus',
    project2: '/projects/traveloka',
    project3: '/projects/plannee',
    project4: '/projects/campfy',
}
